import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { BrowserRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const Root = () => {
  const { t } = useTranslation();

  return (
    <BrowserRouter>
      <Helmet>
        <title>{t("siteTitle")}</title>
        <meta name="description" content={t("siteTitleContent")} />
        <meta property="og:image" content="/Assets/Images/fidar.png" />
      </Helmet>
      <App />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

reportWebVitals();
